module.exports = __webpack_public_path__ + "static/media/landing-preview-body.769605a8.png";